class GiftcardSlider extends HTMLElement {
  constructor() {
    super();
    this.images = this.querySelector("[data-images]");
    this.trigger = this.querySelector("[data-trigger]");

    const triggerObserver = new IntersectionObserver((entries) => {
      entries.forEach(
        (entry) => {
          if (entry.isIntersecting) {
            this.images.classList.remove("animate-cards--out");
            this.images.classList.add("animate-cards");
          }
        },
        { threshold: 1 },
      );
    });

    const exitObserver = new IntersectionObserver((entries) => {
      entries.forEach(
        (entry) => {
          if (!entry.isIntersecting) {
            this.images.classList.remove("animate-cards");
            this.images.classList.add("animate-cards--out");
          }
        },
        { threshold: 1 },
      );
    });

    triggerObserver.observe(this.trigger);
    exitObserver.observe(this);
  }
}

if (!customElements.get("giftcard-slider")) {
  customElements.define("giftcard-slider", GiftcardSlider);
}
